import { Path } from '@/main/router/routerPath';

import { CRUMB_LABEL_KEY, NAME } from './constants';
import Edit from './Edit.vue';
import List from './List.vue';
import { ServisniPaketyNd } from './nahradniDily';
import { ServisniPaketyPp } from './pracovniPozice';

export const router = new Path().addChildren([
	new Path(NAME, { List, Edit, SelectList: List }, CRUMB_LABEL_KEY),
	ServisniPaketyNd.router,
	ServisniPaketyPp.router,
]);
